/* Scroll infinito nas coleções — Salerita (seguindo o prompt INFINITE SCROLL COLLECTION do Kiko).
   Isolado em window.StoreInfiniteScroll; usa a paginação nativa da Shopify; a paginação normal
   continua no HTML como fallback (sem JS ou em caso de erro). */
(function () {
  'use strict';
  if (window.StoreInfiniteScroll && window.StoreInfiniteScroll.started) return;
  var NS = (window.StoreInfiniteScroll = { started: true });
  var MAX_AUTO_RETRIES = 2;
  var state = null;
  var reinitTimer = null;

  function els() {
    var wrap = document.querySelector('#CollectionAjaxResult .collection-grid__wrapper');
    if (!wrap) return null;
    var first = wrap.querySelector('.grid-product');
    if (!first) return null;
    return { wrap: wrap, grid: first.parentElement, pag: wrap.querySelector('.pagination') };
  }

  function nextFrom(root) {
    var a = root && root.querySelector('.pagination .next a');
    if (!a) return null;
    try { return new URL(a.getAttribute('href'), window.location.origin).href; } catch (e) { return null; }
  }

  function teardown() {
    if (!state) return;
    if (state.obs) state.obs.disconnect();
    if (state.ctrl) state.ctrl.abort();
    if (state.sentinel) state.sentinel.remove();
    if (state.status) state.status.remove();
    if (state.pag) state.pag.style.display = '';
    state = null;
  }

  function init() {
    teardown();
    var e = els();
    if (!e) return;
    var next = nextFrom(e.wrap);
    var st = {
      grid: e.grid, pag: e.pag, next: next, loading: false, fails: 0,
      loadedUrls: new Set([window.location.href]), ids: new Set()
    };
    e.grid.querySelectorAll('.grid-product').forEach(function (it) { st.ids.add(key(it)); });
    state = st;
    if (!next) return; // coleção com uma só página: nada a fazer

    var status = document.createElement('div');
    status.className = 'sis-status';
    status.setAttribute('aria-live', 'polite');
    e.grid.insertAdjacentElement('afterend', status);
    st.status = status;

    var sentinel = document.createElement('div');
    sentinel.className = 'sis-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    status.insertAdjacentElement('afterend', sentinel);
    st.sentinel = sentinel;

    if (e.pag) e.pag.style.display = 'none'; // escondida visualmente; continua no HTML para SEO/fallback

    st.obs = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) load();
    }, { rootMargin: '1000px 0px' });
    st.obs.observe(sentinel);
  }

  function key(it) {
    if (it.dataset.productId) return 'id:' + it.dataset.productId;
    if (it.dataset.productHandle) return 'h:' + it.dataset.productHandle;
    var a = it.querySelector('a[href*="/products/"]');
    return a ? 'u:' + a.getAttribute('href').split('?')[0] : 'x:' + Math.random();
  }

  function finish(st) {
    if (st.obs) st.obs.disconnect();
    if (st.sentinel) st.sentinel.remove();
    st.status.classList.remove('is-loading');
    st.status.textContent = 'Todos os produtos foram apresentados.';
  }

  function showRetry(st) {
    st.status.classList.remove('is-loading');
    st.status.textContent = '';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sis-retry btn btn--secondary btn--small';
    b.textContent = 'Tentar novamente';
    b.addEventListener('click', function () { st.fails = 0; load(); });
    st.status.appendChild(b);
    if (st.pag) st.pag.style.display = ''; // volta a mostrar a paginação normal
  }

  function load() {
    var st = state;
    if (!st || st.loading || !st.next) return;
    if (st.loadedUrls.has(st.next)) { finish(st); return; } // proteção contra ciclos
    st.loading = true;
    st.status.textContent = 'A carregar mais produtos…';
    st.status.classList.add('is-loading');
    st.ctrl = new AbortController();
    var url = st.next;

    fetch(url, { signal: st.ctrl.signal, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (st !== state) return; // grelha mudou entretanto (filtro/ordenação)
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.querySelector('#CollectionAjaxResult .collection-grid__wrapper');
        var items = wrap ? wrap.querySelectorAll('.grid-product') : [];
        st.loadedUrls.add(url);
        st.loading = false;
        if (!items.length) { st.next = null; finish(st); return; }

        var frag = document.createDocumentFragment();
        var added = 0;
        items.forEach(function (it) {
          var k = key(it);
          if (st.ids.has(k)) return;
          st.ids.add(k);
          it.removeAttribute('data-aos'); // evita cartões invisíveis à espera da animação AOS
          it.classList.add('aos-animate');
          it.querySelectorAll('img').forEach(function (img) {
            if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
            img.setAttribute('decoding', 'async');
          });
          frag.appendChild(document.importNode(it, true));
          added++;
        });
        st.grid.appendChild(frag);
        st.fails = 0;
        st.status.classList.remove('is-loading');
        st.status.textContent = '';

        var n = nextFrom(wrap);
        st.next = n && !st.loadedUrls.has(n) ? n : null;
        document.dispatchEvent(new CustomEvent('infinite-scroll:loaded', { detail: { added: added } }));

        if (!st.next) { finish(st); return; }
        // volta a observar: se o sentinel ainda estiver visível, carrega o próximo lote
        st.obs.unobserve(st.sentinel);
        st.obs.observe(st.sentinel);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        console.warn('[StoreInfiniteScroll]', err);
        st.loading = false;
        st.fails++;
        if (st.fails <= MAX_AUTO_RETRIES) {
          setTimeout(function () { if (st === state) load(); }, 1500 * st.fails);
        } else {
          showRetry(st);
        }
      });
  }

  // Filtros/ordenação AJAX do tema substituem a grelha: reinicia quando isso acontece.
  function watch() {
    var root = document.getElementById('CollectionAjaxResult');
    if (!root) return;
    new MutationObserver(function () {
      if (state && state.grid && state.grid.isConnected) return;
      clearTimeout(reinitTimer);
      reinitTimer = setTimeout(init, 100);
    }).observe(root, { childList: true, subtree: true });
  }

  NS.init = init;
  function start() { init(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
